import MqttClient from './mqttclient'

export default new MqttClient()


// WEBPACK FOOTER //
// ./src/services/mqtt/mqttclient/index.js